module.exports = __webpack_public_path__ + "img/ClickForSound_14.4f1d99dd.png";